export const LinkStyling = {
    textDecoration: "none",
    color: "white",
};

export const backendAPI = "https://capstone-backend-alpha.vercel.app";
// export const backendAPI = "http://localhost:4000";
